"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeGroupBySingleFieldPointerMethod = void 0;
const _ = __importStar(require("lodash"));
const calc_agent_1 = require("@finley-technologies/calc-agent");
const common_1 = require("@finley-technologies/common");
// This method is not required anymore. You should instead
// use declarative config with
// type: 'exposureByGroup';
const makeGroupBySingleFieldPointerMethod = ({ field, method, type, exclusion, }) => {
    return {
        method,
        requiredFields: [
            `baseFields.${field}`,
            'concentrationLimitFields.eligibleExposureLessConcentrationLimitKickouts',
        ],
        pointerImplementation: ({ concentrationReceivables, valueConfig, totalConcentrationExposure, }) => {
            (0, common_1.finleyAssert)(valueConfig.type === 'number', `unsupported concentration limit type in concentration limit ${method}`);
            const concentrationLimit = valueConfig.limit;
            const concentrationLimitValueType = valueConfig.valueType;
            concentrationReceivables.forEach((rec) => {
                (0, common_1.finleyAssert)(typeof rec.baseFields[field] === type, `baseFields.${field} must be defined to run ${method}. Found [${rec.baseFields[field]}}]`);
            });
            const grouped = _.groupBy(concentrationReceivables, (rec) => rec.baseFields[field]);
            if (exclusion) {
                // Order grouped field names in descending order by sum of exposure
                const topFields = _.sortBy(Object.keys(grouped), (groupedField) => _.sumBy(grouped[groupedField], (receivable) => receivable.concentrationLimitFields
                    .eligibleExposureLessConcentrationLimitKickouts)).reverse();
                // Remove field for top N groups as specified by exclusion option
                topFields
                    .slice(0, exclusion.largestNumberOfGroups)
                    .forEach((groupedField) => {
                    delete grouped[groupedField];
                });
            }
            const standardBorrowingBaseReductions = _.map(_.values(grouped), (receivables) => {
                return (0, calc_agent_1.calculateStandardConcentrationLimitKickouts)({
                    concentrationLimit,
                    totalConcentrationExposure,
                    concentrationReceivables: receivables,
                    concentrationLimitValueType,
                });
            });
            let concentrationAmount = 0;
            const concentrationKickouts = _.reduce(standardBorrowingBaseReductions, (result, { calculations, kickouts }) => {
                _.forEach(_.toPairs(kickouts), ([finleyReceivableId, kickout]) => {
                    if (kickout === 0)
                        return true;
                    concentrationAmount += calculations.concentrationAmount || 0;
                    if (!result[finleyReceivableId]) {
                        // eslint-disable-next-line no-param-reassign
                        result[finleyReceivableId] = 0;
                    }
                    // eslint-disable-next-line no-param-reassign
                    result[finleyReceivableId] += kickout;
                    return true;
                });
                return result;
            }, {});
            return {
                kickouts: concentrationKickouts,
                calculations: {
                    concentrationAmount,
                    concentrationLimit: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations
                            .concentrationLimit
                        : 0,
                    concentration: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations.concentration
                        : 0,
                },
            };
        },
    };
};
exports.makeGroupBySingleFieldPointerMethod = makeGroupBySingleFieldPointerMethod;
//# sourceMappingURL=makeGroupBySingleFieldPointerMethod.js.map